import { Component, HostListener, OnInit } from '@angular/core';
import { ThemesServiceV2 } from '@core/themes/themes.service';
import { LoginService } from './pages/login/login.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'Car Research XRM';
  private _time = 'xrmng2_windowClosed_At';

  constructor(private loginsvc: LoginService,
    private themeServiceV2: ThemesServiceV2) {

    const vt1 = sessionStorage.getItem(this._time);
    if (!vt1) {
      // 1st time load
      this.loginsvc.logout();
    } else {
      // page refresh
    }
  }

  ngOnInit(): void {
    this.themeServiceV2.initTheme();
  }

  @HostListener('window:unload', ['$event'])
  handleWindowUnload(event) {
    sessionStorage.setItem(this._time, '' + (new Date().getTime()));
  }
}
